import controller from './postal-address.controller';
import template from './postal-address.html';

export default {
	template,
	bindings: {
		disabled:    '<?ngDisabled',
		focus:       '@?',
		key:         '@?', // for use in formio
		onSelect:    '&?',
		options:     '<?',
		placeholder: '@?',
		value:       '=?ngModel',
	},
	controller,
	require:  {
		ngModelCtrl: '?ngModel',
		parent:      '^^?kform',
	},
};
